// src/redux/thunks/testRecommendationThunk.js
// src/reduxs/referTestToLab.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const referTestToLab = createAsyncThunk(
  "appointments/referTestToLab",
  async ({ OtherMedicalUser, test, appointmentId }, { rejectWithValue }) => {
    try {
      if (!OtherMedicalUser?._id || !test?.testid || !appointmentId) {
        return rejectWithValue("Missing required fields to refer test.");
      }

      const testData = {
        testid: test.testid,
        testType: test.testType,
        doctorDescription: test.doctorDescription || "",
        OtherMedicalUser: {
          _id: OtherMedicalUser._id,
          fullName: OtherMedicalUser.fullName,
          email: OtherMedicalUser.email,
          phone: OtherMedicalUser.phone,
          profilePic: OtherMedicalUser.profilePic || "",
          profession: OtherMedicalUser.profession || "",
          city: OtherMedicalUser.city || "",
          state: OtherMedicalUser.state || "",
          postalCode: OtherMedicalUser.postalCode || "",
          district: OtherMedicalUser.district || "",
          village: OtherMedicalUser.village || "",
          googleMapLink: OtherMedicalUser.googleMapLink || "",
          categoryPath: OtherMedicalUser.categoryPath || [],
        },
      };

      const baseUrl =
        process.env.REACT_APP_BACKEND_BASE_URL || "http://localhost:5000";

      const response = await axios.put(
        `${baseUrl}/appointments/${appointmentId}/test-recommendations`,
        testData,
      );

      return { appointmentId, testid: test.testid, updatedFields: testData };
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || "Unknown error",
      );
    }
  },
);

export default referTestToLab;
